<template>
  <section class="documents">
    <div class="container">
      <v-app>
        <div class="pa-7">
          <h1>Vínculo de Parceiros</h1>
          <v-divider class="mt-1 mb-5"></v-divider>

          <div class="pa-2 mb-2">
            <div class="d-flex flex-row mb-6 justify-space-around">
              <div class="pa-5 text-center">
                <div class="font-weight-bold mb-3">Download da planilha de vinculos:</div>
                <download-excel :name="geraNomePlanilha()" :fetch="buscaVinculosDownload">
                  <v-btn
                    :loading="loaderDownload"
                    :disabled="loaderDownload"
                    color="#005a64"
                    class="white--text"
                  >
                    <v-icon
                      left
                      dark
                    >
                      mdi-cloud-download
                    </v-icon>
                    Download
                  </v-btn>
                </download-excel>
              </div>
              <div class="pa-5 text-center">
                <div class="font-weight-bold mb-3">Upload da planilha de vinculos:</div>
                <input
                  type="file"
                  accept=".xls, .xlsx"
                  ref="fileToUpload"
                  @change="lerPlanilha($event)" 
                  style="display: none"
                  id="upload"
                >
                <v-btn
                  :loading="loaderUpload"
                  :disabled="loaderUpload"
                  color="#005a64"
                  class="white--text"
                  @click="$refs.fileToUpload.click()"
                >
                  <v-icon
                    left
                    dark
                  >
                    mdi-cloud-upload
                  </v-icon>
                  Upload
                </v-btn>
              </div>
            </div>
          </div>
          
          <div class="table" style="overflow-x: auto">
            <table id="table">
              <thead>
                <tr style="text-align: center;">
                  <th>Vendedor</th>
                  <th>Parceiro</th>
                  <th>Canal de Vendas</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, index) in vinculos" :key="index">
                  <td>
                    {{ v.nomeVendedor }}
                  </td>
                  <td>
                    {{ v.nomeParceiro }}
                  </td>
                  <td>
                    {{ v.nomeCanalVendas }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <div class="text-center">
            <v-pagination
              color="#005a64"
              v-model="page"
              :length="totalPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>

        </div>
        <!-- Dialogs -->
        <!-- Erro -->
        <v-dialog v-model="errorDialog.active" persistent width="400">
          <v-card>
            <v-card-title class="text-h5" style="background: #005a64; color: white;">Ops...</v-card-title>
            <div class="pa-7" v-html="errorDialog.message"></div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#005a64" text @click="errorDialog.active = false">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Upload -->
        <v-dialog v-model="uploadDialog" persistent width="400">
          <v-card>
            <v-card-title class="text-h5" style="background: #005a64; color: white;">Atenção!</v-card-title>
            <div class="pa-7">
              <div>Nome do arquivo a ser realizado o upload:</div>
              <div class="font-weight-bold">{{ arquivoUpload ? arquivoUpload.name : '' }}</div>
              <div>Quantidade de registros: <span class="font-weight-bold">{{ qtdRegistros }}</span></div>
              <div class="mt-5">
                Deseja prosseguir com o upload da tabela atualiza?
              </div>
            </div>
            <v-card-actions>
              <v-btn 
                color="red" 
                text 
                @click="uploadDialog = false; arquivoUpload = null; limpaArquivoSelecionado();"
              >
                Não
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="#005a64" text @click="uploadVinculos()">Sim</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Loading -->
        <v-dialog v-model="loading.active" persistent width="300">
          <v-card color="var(--standardGreen)" dark>
            <v-card-text style="padding: 27px">
              <div v-html="loading.message"></div>
              <v-progress-linear
                style="margin-top: 15px"
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="success.active" persistent width="400">
          <v-card>
            <v-card-title class="text-h5" style="background: #005a64; color: white;">Sucesso!</v-card-title>
            <div class="pa-7" v-html="success.message"></div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#005a64" text @click="sucessoUpload()">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-app>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";



export default {
  data() {
    return {
      baseURL: 'https://www.leverosintegra.com.br/Map/api',
      errorDialog: {
        active: false,
        message: null
      },
      uploadDialog: false,
      loading:{
        active: false,
        message: null
      },
      success: {
        active: false,
        message: null
      },
      token: null,
      vinculos: [],
      vinculosUpload: [],
      totalPaginas: 0,
      page: 1,
      loaderDownload: false,
      loaderUpload: false,
      arquivoUpload: null,
      qtdRegistros: null,
      contentFile: null
    };
  },

  watch: {
    page() {
      this.buscaVinculos();
    }
  },

  created() {
    // Recupera o token do usuário logado
    let dados = JSON.parse(localStorage.getItem("login"));
    this.token = dados.token;
    this.buscaVinculos();
  },

  methods: {
    sucessoUpload() {
      this.success.active = false; 
      window.location.href = '/panel/ManagementPartner';
    },

    buscaVinculos() {
      this.loading.message = "Buscando dados, por favor aguarde...";
      this.loading.active = true;
      axios.get(`${this.baseURL}/ManagementPartner?token=${this.token}&paginaAtual=${this.page}`)
      .then(res => {
        this.vinculos = res.data.vinculos;
        this.totalPaginas = res.data.totalPaginas;
        this.loading.active = false;
      }).catch(err => {
        if (err && err.response && err.response.status && err.response.status === 401) {
          this.errorDialog.message = "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!";
          this.errorDialog.active = true;
        } else {
          this.errorDialog.message = "Erro ao buscar dados, tente novamente!";
          this.errorDialog.active = true;
        }
        this.loading.active = false;
        console.log(err)
      })
    },

    async buscaVinculosDownload(){
      this.loaderDownload = true;
      const response = await axios.get(`${this.baseURL}/ManagementPartner?token=${this.token}`);
      if (response.status === 200) {
        this.loaderDownload = false;
        return response.data;
      } else if (response.status === 401) {
        this.errorDialog.message = "Seu login expirou ou você efetuou acesso em outra máquina. Realize o login novamente!";
        this.errorDialog.active = true;
      } else {
        this.errorDialog.message = "Erro ao realizar o download, tente novamente!";
        this.errorDialog.active = true;
      }
      this.loaderDownload = false;
    },

    uploadVinculos() {
      this.uploadDialog = false;
      this.loading.message = "Subindo nova planilha de parceiros, por favor aguarde...";
      this.loading.active = true;
      axios({
        method: "post",
        url: `${this.baseURL}/ManagementPartner?token=${this.token}`,
        data: this.vinculosUpload
      }).then(res => {
        if (res && res.data && res.data === 'Upload realizado com sucesso!') {
          this.loading.active = false;
          this.success.message = res.data;
          this.success.active = true;
        }
      }).catch(err => {

        let complement = err && err.response && err.response.data && err.response.data.ExceptionMessage ?
          err.response.data.ExceptionMessage : err

        this.loading.active = false;
        this.errorDialog.message = `Erro ao realizar o upload, tente novamente! ${JSON.stringify(complement)}`;
        this.errorDialog.active = true;
        console.log(err)
      })
    },

    lerPlanilha(event) {
      this.arquivoUpload = event.target.files ? event.target.files[0] : null;

      // Valida tipo de documento
      if (this.arquivoUpload) {
        let archiveType = this.arquivoUpload.name.split('.')[1];
        if (archiveType !== 'xls' && archiveType !== 'xlsx') {
          this.arquivoUpload = null;
          this.errorDialog.message = "Tipo de arquivo selecionado inválido!";
          this.errorDialog.active = true;
        } else {
          let r = new FileReader();
          this.loaderUpload = true;
          r.readAsBinaryString(this.arquivoUpload);
          r.onload = (e) => {
            this.contentFile = this.processExcel(e.target.result);
          };
          r.onloadend = () => {
            this.loaderUpload = false;
            this.validaPlanilha();
          }
        }
      }
    },

    processExcel(data) {
      let workbook = XLSX.read(data, {
        type: "binary"
      });

      let res = this.toJson(workbook);
      return res;
    },

    toJson(workbook) {
      let result;
      workbook.SheetNames.forEach(function (sheetName) {
        let roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
          header: 1,
          raw: false,
        });
        if (roa.length) result = roa;
      });
      return result;
    },

    validaPlanilha() {
      // Valida colunas da planilha
      if (this.contentFile[0].length !== 3) {
        this.errorDialog.message = "Campos da planilha inválidos, verifique!";
        this.errorDialog.active = true;
        this.limpaArquivoSelecionado();
        return;
      }

      // Valida campos
      if (this.contentFile[0][0] !== 'canalVendas' ||
          this.contentFile[0][1] !== 'codigoParceiro' ||
          this.contentFile[0][2] !== 'codigoVendedor') {

        this.errorDialog.message = "Campos da planilha inválidos, verifique!";
        this.errorDialog.active = true;
        this.limpaArquivoSelecionado();
        return;
      }

      this.preparaDados();
    },

    preparaDados() {
      // Prepara dados para serem enviados para a API
      let header = this.contentFile[0];
      let arrayTemp = this.contentFile;
      arrayTemp.shift();

      let arrayVinculos = [];
      let countLinha = 0;
      try {
        for (let a in arrayTemp) {
          countLinha++;
          // Valida se são campos numéricos
          if (isNaN(arrayTemp[a][0]) || isNaN(arrayTemp[a][1]) || isNaN(arrayTemp[a][2])) {
            throw "Não numérico";
          }

          // Monta o objeto
          let obj = {};
          obj[header[0]] = parseInt(arrayTemp[a][0]);
          obj[header[1]] = parseInt(arrayTemp[a][1]);
          obj[header[2]] = parseInt(arrayTemp[a][2]);
          arrayVinculos.push(obj);
        }
      } catch {
        this.errorDialog.message = "Erro ao converter dados da planilha, verifique se a planilha possui campos vazios ou letras em campos numéricos! <br/><strong>Erro linha: " + countLinha + "</strong>";
        this.errorDialog.active = true;
        this.limpaArquivoSelecionado();
        return;
      }

      // Atualiza as váriaveis
      this.qtdRegistros = arrayVinculos.length;
      this.vinculosUpload = arrayVinculos;

      // Abre o dialogo de upload
      this.uploadDialog = this.arquivoUpload ? true : false;
    },

    geraNomePlanilha() {
      const dataAtual = new Date()
      return 'Vínculos de Parceiros (' + dataAtual.toISOString().split('T')[0] + ')';
    },

    limpaArquivoSelecionado() {
      document.getElementById("upload").value = "";
    }
  },
};
</script>

<style lang="scss" scoped>
.documents {
  .container {
    max-width: 90%;
    margin: 0 auto;

    .header {
      display: flex;
      margin: 20px 0;

      button {
        background: var(--standardGreen);
        color: var(--customWhite);
        border-radius: 5px;
        padding: 10px;
        width: 40%;
      }

      input {
        border-bottom: 1px solid var(--customGray-500);
        outline: none;
        margin-left: 20px;
        color: var(--customGray-500);
        width: 100%;
      }
    }

    .loader {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;

      i {
        color: var(--customBlue);
        font-size: 4rem;
      }
    }

    .table {
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            th {
              background: var(--customGray-70);
              padding: 5px;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 10px;
              border-bottom: 1px solid var(--customGray-100);
              text-align: center;

              button {
                background: var(--customGray-100);
                color: var(--customGray-800);
                border-radius: 10px;
                padding: 5px;
                outline: none;
              }

              a {
                color: var(--customDarkGreen);
              }
            }
          }
        }
      }
    }
  }
}
</style>